import { FunctionalComponent, h } from 'preact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons/faMapMarkerAlt';
import { useMemo } from 'preact/hooks';
import { useTranslation } from '../../../hooks/use-translation';

interface Props {
	stops: number;
}

const TrackingDriverRoute: FunctionalComponent<Props> = ({ stops }) => {
	const { t } = useTranslation();
	const message = useMemo(() => {
		if (stops === 1) {
			return t('TRACKING.DRIVER_ROUTE_ONE_STOP_MESSAGE');
		}

		return `${t('TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART1')} ${stops} ${t(
			'TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART2'
		)}`;
	}, [stops]);

	return (
		<div className="tracking-driver-route" data-testid="tracking-driver-route">
			<FontAwesomeIcon className="route-icon" icon={faMapMarkerAlt} />
			<span className="route-message">{message}</span>
		</div>
	);
};

export default TrackingDriverRoute;
